<template>
  <div class="createMigracoes">
    <el-form
      v-loading="loadingPage"
      :model="ruleForm"
      ref="ruleForm"
      @submit.prevent
      v-on:submit.prevent
    >
      <HeaderPage />
      <el-card>
        <el-row :gutter="20">
          <el-col :lg="8" :sm="6" :md="4" :xs="8">
            <el-form-item prop="id" label="Marketplace">
              <SelectSearchMigracao
                ref="selectMarketplace"
                :model="ruleForm.id"
                @handleObjValue="
                  (x) => {
                    mkt = x;
                  }
                "
                @handleValue="
                  (x) => {
                    ruleForm.id = x;
                  }
                "
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :sm="6" :md="4" :xs="8">
            <el-button
              @click.prevent="submitForm('ruleForm')"
              style="text-align: center"
              class="mt-22"
              type="primary"
            >
              <span>Iniciar Migração</span>
            </el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import SelectSearchMigracao from "@/app/components/Migracao/SelectSearchMigracao";
import { getErrorFilds, makeErrorFilds } from "@/app/plugins/utils";
import { postMigracoes } from "@/app/domains/Config/services";
import { mapGetters } from "vuex";
export default {
  name: "editMigracoes",
  components: {
    HeaderPage,
    SelectSearchMigracao,
  },
  data() {
    return {
      ruleForm: {
        id: "",
      },
      mkt: {},
      loadingPage: false,
      isEditMKT: true,
      listData: {},
    };
  },
  methods: {
    submitForm() {
      this.$refs["ruleForm"].validate(async (valid, i) => {
        if (valid) {
          try {
            this.loadingPage = true;

            if (this.ruleForm.id) {
             let response = await postMigracoes({
                marketplace_id: this.ruleForm.id,
                marketplace_name_store: this.mkt.name,
              });
              
              this.$message({
                showClose: true,
                message: "MarketPlace Migrado com sucesso",
                type: "success",
              });
              await this.$router.push({ name: "config.ListMigracoes.index" });
            }
          } catch (e) {
            this.error = getErrorFilds(e);
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: "error",
            });
          } finally {
            this.loadingPage = false;
          }
        }
      });
    },
  },
  computed: {
    isEdit: function () {
      return !!this.ruleForm.marketplace_id;
    },
    ...mapGetters("Auth", ["currentUser"]),
  },
};
</script>
